import CryptoJS from 'crypto-js';
import { ref } from 'vue';
// import socket from '@/core/services/socket';
import { useStore } from "vuex";
import {
  Buffer,
  createDecipheriv,
} from 'browser-crypto';

const ID_TOKEN_KEY = "id_token" as string;
const TYPE = "TYPE" as string;
const ROLE = "ROLE" as string;
const VERIFIED = "VERIFIED" as string;
const store = useStore();

let preAutorization = { id: null, autorizacion: false, score:'', name:'' } 
const links = ref<any>([]);

// export const onlineChat =  async (user: { USER_CHAT_ID?: string | number } = {}) : Promise<any> => {
  
//   user?.USER_CHAT_ID && socket.emit('message', {
//     type: 'general',
//     channel: 'userStatus', 
//     data: {
//       online: 1,
//       user_id: user?.USER_CHAT_ID
//     }
//   });
// };

export const setLinks = (val) => {
  links.value = val
}

export const getLinks = () => {
  return links.value
}

export const setPreAutorization = (val) => {
  preAutorization = val
}

export const getPreAutorization = () => {
 return preAutorization
}

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  // const lastCookie = document.cookie;
  return window.localStorage.getItem(ID_TOKEN_KEY);
};
export const getTYPE = (): string | null => {
  return window.localStorage.getItem(TYPE);
};
export const getROLE = (): string | null => {
  return window.localStorage.getItem(ROLE);
};
export const getVERIFIED = (): string | null => {
  if(window.localStorage.getItem(VERIFIED)  == '0'){
    return null;
  }else{
    return window.localStorage.getItem(VERIFIED);
  }
};

const decipher = (Token = null) => {
  
  const T = Token ? Token : window.localStorage.getItem('T');
  
  const secret_key = process.env.VUE_APP_TOKEN;

  
  let ivstring, decipher

  if (process.env.VUE_APP_ENV == 'develop'){
    const key = CryptoJS.SHA256(secret_key).toString(CryptoJS.enc.Base64).substr(0, 32);
    const iv = new Buffer.from(key);
    ivstring = iv.toString('hex').slice(0, 16);
    decipher = createDecipheriv('aes256', key, ivstring);
  } else  {
      ivstring = process.env.VUE_APP_IV;
      decipher = createDecipheriv('aes256', secret_key, ivstring);
  }

  let decrypted = decipher.update( T, 'base64', 'utf8');
  decrypted += decipher.final('utf8');
  return JSON.parse(decrypted);
}

export const getPerm = (module: string, path = null) => {
  
  const user = decipher();
 
  
  const perms = user?.permsTo;
  const permiso = perms?.filter((perm) => perm[1] === module);
  
  if (path === '/agency' &&  user.role == "Coordinador de Agencia" ) {
    
    return user.agencyGroup;
  }
  
  return permiso;
 }
export const getDataClient = (token = null) : any => {

 const dataUser = decipher(token);
 
  return dataUser; 
  
 
 }

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (uuid: string, token?: string): void => {
  if(token){
    window.localStorage.setItem('T', token);
    if (process.env.VUE_APP_WHOSE_IS == 'tfsm'){
      const date = new Date();
          date.setTime(date.getTime() + (1*24*60*60*1000));
          const expires = "; expires=" + date.toUTCString();
          document.cookie = "token" + "=" + (token || "")  + expires + "; path=/";
          localStorage.pStrCookie = "token="+ token;
    }
  }
  window.localStorage.setItem(ID_TOKEN_KEY, uuid);
};
export const saveType = (type: string): void => {
  window.localStorage.setItem(TYPE, type);
};
export const saveRole = (role: string): void => {
  window.localStorage.setItem(ROLE, role);
};
export const saveVerified = (Verified: number): void => {
  window.localStorage.setItem(VERIFIED, Verified.toString());
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};
export const destroyType = (): void => {
  window.localStorage.removeItem(TYPE);
};
export const destroyVerified = (): void => {
  window.localStorage.removeItem(VERIFIED);
};

export default { getToken, saveToken, destroyToken, getTYPE, getROLE, saveType, saveRole, destroyType, saveVerified, getVERIFIED, destroyVerified, getPerm, setPreAutorization, getPreAutorization, setLinks, getLinks, getDataClient,  }; //onlineChat,
